.container {
  min-height: calc(100vh - 64px);
  padding-block: 96px;
  background-color: #f5f5f5;
}

.inner {
  display: grid;
  gap: 64px;
  width: 880px;
  margin-inline: auto;
}

.section {
  display: grid;
  gap: 32px;
}

.heading {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.66px;
}

.cards {
  display: grid;
  grid-template-columns: 576px 272px;
  gap: 32px;
  align-items: start;
}

.multiLineClampBox {
  display: -webkit-box;
  overflow: hidden;
  word-break: break-all;
  -webkit-box-orient: vertical;
}

.singleLine {
  -webkit-line-clamp: 1;
}

.twoLine {
  -webkit-line-clamp: 2;
}

.threeLine {
  -webkit-line-clamp: 3;
}

.cardContainer {
  display: grid;
  gap: 20px;
}

.label {
  font-size: 16px;
}

.card {
  display: grid;
  overflow: hidden;
  border-radius: 8px;
}

.cardVariants {
  &[data-size='xs'] {
    grid-template-columns: 62px 210px;
    height: 62px;

    img {
      height: 100%;
    }
  }

  &[data-size='sm'] {
    grid-template-columns: 142px 434px;
    height: 142px;

    img {
      height: 100%;
    }
  }
}

.thumbnail {
  width: 100%;
  aspect-ratio: 1.91 / 1;
  object-fit: cover;
}

.text {
  display: grid;
  background-color: var(--color-white);
}

.textVariants {
  &[data-size='xs'] {
    padding: 12px 9px;
  }

  &[data-size='sm'] {
    display: unset;
    padding: 12px;
    padding-bottom: 24px;
  }

  &[data-size='md'] {
    padding: 9px;
  }

  &[data-size='lg'] {
    padding: 9px 12px;
  }
}

.titleVariants {
  &[data-size='xs'] {
    -webkit-line-clamp: 1;
    font-size: 12px;
  }

  &[data-size='sm'] {
    display: block;
    height: 18px;
    text-overflow: ellipsis;
    -webkit-line-clamp: unset;
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
  }

  &[data-size='md'] {
    font-size: 12px;
    font-weight: 600;
  }

  &[data-size='lg'] {
    font-size: 18px;
    font-weight: 600;
  }
}

.descriptionVariants {
  &[data-size='xs'] {
    display: none;
  }

  &[data-size='sm'] {
    display: -webkit-box;
    padding-top: 8px;
    overflow: hidden;
    -webkit-line-clamp: 3;
    font-size: 18px;
    word-break: break-all;
    -webkit-box-orient: vertical;
  }

  &[data-size='md'] {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 1;
    font-size: 12px;
    word-break: break-all;
    -webkit-box-orient: vertical;
  }

  &[data-size='lg'] {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 1;
    font-size: 18px;
    word-break: break-all;
    -webkit-box-orient: vertical;
  }
}

.descriptionLgX {
  /** 利用側の設定によってline-clampを上書きするために!importantを使用 */
  -webkit-line-clamp: 2 !important;
}
